export enum PopulationScope {
  Employee = 'Employee',
  EmployeeRecord = 'EmployeeRecord',
  User = 'User',
  Position = 'Position',
  PositionSnapshot = 'PositionSnapshot',
  EclEmployee = 'EclEmployee',
  OmRule = 'OmRule',
  RestructuringEmployee = 'RestructuringEmployee',
  OrganisationManagementActivity = 'OrganisationManagementActivity',
  PositionRequest = 'PositionRequest'
}
